import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "flex"
};
const _hoisted_2 = {
  key: 0,
  class: "pt-1 px-1"
};
const _hoisted_3 = ["disabled"];
import LlTooltip from '@/components/LlTooltip.vue';
export default {
  __name: 'LlCheckbox',
  props: {
    variant: String,
    color: String,
    prependIcon: String,
    modelValue: Boolean,
    label: String,
    // Select-all over a partial selection.
    indeterminate: {
      type: Boolean,
      default: false
    },
    // The accessible name when there is no visible label, e.g. a row checkbox.
    ariaLabel: String,
    // Fits a dense table row: compact density still holds the input to 40px tall,
    // which roughly doubles a one-line row. This draws a 15px square (20px icon)
    // inside a 24px click target, the WCAG 2.2 minimum, and fixes the width:
    // Vuetify's input grid reports a zero minimum width, so a table column would
    // otherwise not make room and the box spills into the next cell.
    dense: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    labelClass: {
      type: String,
      default: 'text-sm'
    },
    info: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue', 'checkboxClick'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;

    // Toggle checkbox value when label is clicked
    const toggleCheckbox = () => {
      if (props.disabled) {
        return;
      } else {
        const newValue = !props.modelValue;
        emit('update:modelValue', newValue);
        emit('checkboxClick');
      }
    };
    const updateValue = value => {
      emit('update:modelValue', value);
      emit('checkboxClick');
    };
    return (_ctx, _cache) => {
      const _component_v_checkbox = _resolveComponent("v-checkbox");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_v_checkbox, {
        variant: __props.variant,
        color: __props.color,
        "prepend-icon": __props.prependIcon,
        text: "",
        density: "compact",
        "hide-details": "true",
        modelValue: __props.modelValue,
        indeterminate: __props.indeterminate,
        "aria-label": __props.ariaLabel ?? __props.label,
        class: _normalizeClass([
        // The empty box only: Vuetify draws it as a heavy dark outline. Checked and
        // indeterminate boxes keep their colour.
        '[&_.mdi-checkbox-blank-outline]:!text-gray-400 [&_.mdi-checkbox-blank-outline]:!opacity-100', __props.dense ? '!w-6 !flex-none [&_.v-selection-control]:!min-h-0 [&_.v-selection-control]:![--v-selection-control-size:24px] [&_.v-selection-control_.v-icon]:!text-[20px]' : '[&_.v-selection-control_.v-icon]:!text-[20px]']),
        "onUpdate:modelValue": updateValue,
        disabled: __props.disabled,
        readonly: __props.disabled
      }, null, 8, ["variant", "color", "prepend-icon", "modelValue", "indeterminate", "aria-label", "class", "disabled", "readonly"]), __props.label || __props.info ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("label", {
        class: _normalizeClass(__props.labelClass),
        disabled: __props.disabled,
        onClick: toggleCheckbox
      }, [_createTextVNode(_toDisplayString(__props.label) + " ", 1), _withDirectives(_createElementVNode("span", {
        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
      }, [_createVNode(LlTooltip, {
        text: __props.info,
        icon: "help"
      }, null, 8, ["text"])], 512), [[_vShow, __props.info.length]])], 10, _hoisted_3)])) : _createCommentVNode("", true)]);
    };
  }
};